import { FC } from 'react';

import { TranscriptChunk } from '@/shared/api/transcriptor/transcriptorApi';

import { formatTimestamp } from '../lib/formatTimestamp';
import styles from '../TranscriptView.module.scss';

type TranscriptChunkButtonProps = {
  chunk: TranscriptChunk;
  fragmentId: string;
  index: number;
  onClick: (fragmentId: string, start: number) => void;
};

export const TranscriptChunkButton: FC<TranscriptChunkButtonProps> = (
  props,
) => {
  const { chunk, fragmentId, index, onClick } = props;

  return (
    <button
      key={`${fragmentId}-${index}`}
      type="button"
      data-component="transcript-time-chunk"
      className={styles.chunk}
      onClick={() => onClick(fragmentId, chunk.start)}
    >
      <span className={styles.timestamp}>{formatTimestamp(chunk.start)}</span>
      <span className={styles.text}>{chunk.text}</span>
    </button>
  );
};
